import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, catchError, lastValueFrom, throwError } from 'rxjs';
import { Post } from 'src/models/blog';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiService: any;
  listPosts: any;
  allPosts: any;
  filteredPosts: Array<Post> = [];
  public url = `${environment.url}/data/`;
  BACKEND_URL: string;
  categories:any = [];
  posts: Array<Post> = [];
  post: any;
  products: any[] | null = null;
  loadingCategories:any;
  postsEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  postEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public http: HttpClient,
    private router: Router

  ) {
    this.BACKEND_URL = environment.BACKEND_URL;
    this.BACKEND_URL = environment.BACKEND_URL;
  }

  public async loadProductLine(categoryId: any) {
    return await this.loadCategories().then(data => {
      let result = null;
      data.map((linha:any) => {
        if (linha.id == categoryId) {
          result = linha
          return
        } else {
          linha.categorias?.map((category: any) => {
            if (category.id == categoryId) {
              result = category
              return
            } else {
              category.subcategorias?.map((subcategory: any) => {
                if (subcategory.id == categoryId) {
                  result = subcategory
                  return
                }
              })
            }
          })
        }
      })
      return result
   })}

   async getCategories(){
    let result = await this.http.get<any[]>(`assets/data/categorias.json`).toPromise();
    result = result!.map(elem => {
      let categoriesTemp = JSON.parse(elem['linhas'])
      function transformToObject(obj: any) {
        try {
          obj = JSON.parse(obj)
          if (obj && typeof (obj) == 'object') {
            for (let ind in obj) {
              for (let index in obj[ind]) {
                obj[ind][index] = transformToObject(obj[ind][index])
              }
            }
          }
        } catch (error) { }
        return obj
      }
      for (let property in categoriesTemp) {
        categoriesTemp[property] = transformToObject(categoriesTemp[property])
      }
      return categoriesTemp
    })
    this.categories = result;
    await this.loadCategoriesWithLink();
   }

   public async loadCategories() {
    if(this.categories.length > 0)
      return this.categories;
    if (this.loadingCategories) {
      await this.loadingCategories;
      return this.categories;
    }

    this.loadingCategories = this.getCategories();

    await this.loadingCategories;

    this.loadingCategories = null;

    return this.categories;
   }
   async loadCharacteristics() {
    return await this.http.get<any[]>(`assets/data/caracteristicas.json`).toPromise();
  }
  async loadPrductAttributes() {
    return this.http.get<any[]>(`assets/data/produto_atributo.json`).toPromise();
  }
  async loadAttributes() {
    return this.http.get<any[]>(`assets/data/atributos.json`).toPromise();
  }

  // public orderProductsByOutOfLine(products: any[]) {
  //   return this.filterProducts(products, '');
  // }

  getImage(url: string): Observable<any> {
    return this.http.get(url, {headers: {'crossorigin':'anonymous', 'access-control-request-method':'GET',"Access-Control-Request-Headers": "Content-Type","sec-fetch-dest": "image",}});
  }

  async loadProducts() {

    if(this.products){
      return this.products
    }

    return await this.http.get<any[]>(`assets/data/produtos.json`).toPromise().then(res =>{
      if(res){
        this.products = this.ordenarPorTipo(res);
        return this.products;
      }
      return [];
    });
  }

  loadProductsFilter() {
    return this.http.get<any[]>(`assets/data/produtos.json`);
  }
  async loadQualityTests() {
    return await this.http.get<any[]>(`assets/data/teste_qualidade.json`).toPromise();
  }
  async loadPrductQualityTests() {
    return await this.http.get<any[]>(`assets/data/produto_teste_qualidade.json`).toPromise();
  }
  public loadAssistencia() {
    return this.http.get<any[]>(`assets/data/assistencias.json`);
  }
  public loadResellers() {
    return this.http.get<any[]>(`assets/data/revendas.json`);
  }
  public loadCapas() {
    return this.http.get<any[]>(`assets/data/capa_secoes.json`);
  }

  public async loadProductsCategories() {
    return await lastValueFrom(this.http.get<any[]>(`assets/data/produto_categoria.json`));
   }
   public loadBlog() {
    return this.http.get<any[]>(`assets/data/blog.json`);
   }
   public loadBlogCategoria() {
    return this.http.get<any[]>(`assets/data/blog-categoria.json`);
   }
   public loadBanners() {
      return this.http.get<any[]>(`assets/data/banners.json`)
  }
  loadPosts() {
    return this.http.get<Post[]>(`assets/blog/blog_posts.json`)
  }

  public loadProductImages(){
    return this.http.get<any[]>(`assets/data/produto_imagens.json`);
  }

  public getCover(post: Post) {

  if (post) {
    if (post.midias.length > 0) {
      const url = post.midias[0].media_details.sizes.full.source_url;
      if (url != '' && url != undefined) {
        return url
      }
    }
  }
    return `assets/images/blukit-missao.png`;
  }

  public getTags(): Observable<any[]> {
    const itens = this.http.get<any[]>(`assets/blog/blog_tags.json`);
    return itens;

  }
  public getPostsCategories(): Observable<any[]> {
    const categorias = this.http.get<any[]>(`assets/blog/blog_categories.json`);

    return categorias;
  }
  public loadPerguntasFrequentes() {
    return this.http.get<any[]>(`assets/data/perguntas_frequentes.json`);
  }
  public loadDownloads() {
    return this.http.get<any[]>(`assets/data/downloads.json`);
  }
  public loadMensagens() {
    return this.http.get<any[]>(`assets/data/mensagens.json`);
  }
  public loadEstadosCidades() {
    return this.http.get<any[]>(`assets/data/estados-cidades.json`);
  }

  public async getCategoriesWithProductsFiltered(id: string) {
    let categoriesWithProducts = await this.loadProductsCategories();
    const categoriesWithProductsFiltered: any = categoriesWithProducts.filter((c: any) => c.codCat == id);
    return categoriesWithProductsFiltered;
  }
  public async getFilteredProductsByCategories(routParamSlug: string) {
    let cat = await this.getCategoriesWithProductsFiltered(routParamSlug);
    return this.getProductsByCategorySync(cat);
  }

  public async getCategoryByIdSlug(categorySlug: any) {
    let categories = await this.loadCategories();
    let result = null;
    categories.map((linha: any) => {
      if (linha.slug == categorySlug) {
        result = linha
        return
      } else {
        linha.categorias?.map((category: any) => {
          if (category.slug == categorySlug) {
            result = category
            return
          } else {
            category.subcategorias?.map((subcategory: any) => {
              if (subcategory.slug == categorySlug) {
                result = subcategory
                return
              }
            })
          }
        })
      }
    })
    return result
  }

  public async getProductsByCategorySync(categoriesToFilter: any[]) {
    let productsIds = categoriesToFilter.map((obj: any) => obj.codPro);
    let productsAll = await this.loadProducts();
    const listFiltered = productsAll ? productsAll.filter((obj: any) => productsIds.includes(obj.codPro)) : [];
    return listFiltered;
  }
  uploadFileAnexo(object: any) {
    return this.http.post<any>(
      `${this.BACKEND_URL}api/upload/faleconosco`,
      object
    );
  }

  registerNewsletter(object: any): Observable<any> {
    return this.http.post<any>(
      `${this.BACKEND_URL}api/newsletter/new`,
      object
    ).pipe(
      catchError(this.handleError)
    );
  }

  verifyTokenValid(token: string): Observable<any> {
    const objToken = {
      recaptcha: token
    }
    return this.http.post<any>(
      `${this.BACKEND_URL}api/validate-recaptcha`,
      objToken
    ).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Erro do lado do cliente
      console.error('Ocorreu um erro:', error.error.message);
    } else {
      // Erro retornado pelo servidor
      console.error(
        `Código do erro ${error.status}, ` +
        `mensagem: ${error.error}`);
    }
    return throwError('Algo deu errado; por favor, tente novamente mais tarde.');
  }

  mensagensNew(object: any) {
    return this.http.post<any>(
      `${this.BACKEND_URL}api/mensagens/new`,
      object
    );
  }

  public filterProducts(produtos: Array<any>, searchString: string): Array<any> {
    // Função para remover acentos

    let moreProducts: any[] = [];
    let keywordNormalized = this.normalizeString(searchString);
    var keywords = keywordNormalized.split(" ");

    const keyword = this.normalizeString(searchString || '');

    const codProResults = produtos.filter(product => (
      this.normalizeString(product.codPro + "").indexOf(keyword) > -1
    ));

    const nomeResults = produtos.filter(product => (
      typeof product.nome === 'string' && this.normalizeString(product.nome).indexOf(keyword) > -1
    ));

    const descricaoResults = produtos.filter(product => (
      (typeof product.desPro === 'string' && this.normalizeString(product.desPro).indexOf(keyword) > -1) ||
      (typeof product.descricao === 'string' && this.normalizeString(product.descricao).indexOf(keyword) > -1) ||
      (typeof product.grupo_variante_descricao === 'string' && this.normalizeString(product.grupo_variante_descricao).indexOf(keyword) > -1) ||
      (typeof product.grupo_relacionamento_descricao === 'string' && this.normalizeString(product.grupo_relacionamento_descricao).indexOf(keyword) > -1)
    ));

    const nomeCompeltoResults = produtos.filter(product => (
      this.verifyMatch(keywords, product.nome)

    ));
    const PALCHAResults = produtos.filter(product => (
      this.verifyMatch(keywords, product.PALCHA)

    ));

    let finalResults = [];

    for (let i = 0; i < codProResults.length; i++) {
      if (finalResults.indexOf(codProResults[i]) === -1)
        finalResults.push(codProResults[i]);
    }
    for (let i = 0; i < nomeResults.length; i++) {
      if (finalResults.indexOf(nomeResults[i]) === -1)
        finalResults.push(nomeResults[i]);
    }
    for (let i = 0; i < nomeCompeltoResults.length; i++) {
      if (finalResults.indexOf(nomeCompeltoResults[i]) === -1)
        finalResults.push(nomeCompeltoResults[i]);
    }
    for (let i = 0; i < descricaoResults.length; i++) {
      if (finalResults.indexOf(descricaoResults[i]) === -1)
        finalResults.push(descricaoResults[i]);
    }
    for (let i = 0; i < PALCHAResults.length; i++) {
      if (finalResults.indexOf(PALCHAResults[i]) === -1)
        finalResults.push(PALCHAResults[i]);
    }

    if(finalResults.length == 0){
      moreProducts = produtos.filter(produto => {
          let matchName = this.verifyMatch(keywords, produto.nome);
          let matchDesPro = this.verifyMatch(keywords, produto.desPro);
          let matchPalCha = this.verifyMatch(keywords, produto.PALCHA);
          let matchCodPro = this.verifyMatch(keywords, produto.codPro);

          return matchName || matchDesPro || matchPalCha || matchCodPro;
      });

      finalResults = moreProducts;
  }

    return this.ordenarPorTipo(finalResults).slice(0, 100);
  }

  public normalizeString(str: string): string {
    if (str && typeof str === 'string') {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase();
    }

    return str
  }

  verifyMatch(keywords: string[], productProperty: string | null) {
    if (productProperty === null) return false;
    let productPropertyNormalized = this.normalizeString(productProperty);

    return keywords.every(keyword => productPropertyNormalized.includes(keyword));
  }

  ordenarPorTipo(products: Array<any>) {
    const novoItems = products.filter(item => item.novo == 1);
    const maisVendidosItems = products.filter(item => item.mais_vendido == 1);
    const foraDeLinhaItems = products.filter(item => item.fora_de_linha == 1);

    const codProItems = products.filter(item => {
      const condition = item.novo !== 1 && item.fora_de_linha !== 1 && item.mais_vendidos !== 1;
      return condition;
    });

    const sortedNovoItems = this.ordernarPorDataCadastro(novoItems);
    const sortedMaisVendidosItems = this.ordenarPorPrioridade(maisVendidosItems);
    const sortedCodProItems = this.ordenarPorPrioridade(codProItems);
    const sortedForaDeLinhaItems = this.ordenarPorPrioridade(foraDeLinhaItems);

    const sortedItemsTemp = [...sortedNovoItems, ...sortedMaisVendidosItems, ...sortedCodProItems, ...sortedForaDeLinhaItems];
    const sortedItems = sortedItemsTemp.filter((item, index, self) =>
      index === self.findIndex((t) => t.codPro === item.codPro)
  );

    return sortedItems;
  }

  ordernarPorDataCadastro(products: any[]) {
    let sortedProducts = products.sort((a, b) => {
      const dateA = new Date(a.dataCadastro).getTime();
      const dateB = new Date(b.dataCadastro).getTime();
      return dateB - dateA;
    });
    return sortedProducts;
  }

  ordenarPorPrioridade(array: any) {
    return array.sort((a: any, b: any) => {
      if (a.prioridade === null && b.prioridade !== null) {
        return 1; // `a` tem prioridade nula, deve ir para o final
      }
      if (a.prioridade !== null && b.prioridade === null) {
        return -1; // `b` tem prioridade nula, deve ir para o final
      }
      if (a.prioridade === null && b.prioridade === null) {
        return 0; // Ambos têm prioridades nulas, não altera a ordem
      }
       // Prioridades são iguais, então ordenar por codPro
      if (a.prioridade === b.prioridade) {

        const codProA = a.codPro ? a.codPro.toString() : '';
        const codProB = b.codPro ? b.codPro.toString() : '';
        return codProA.localeCompare(codProB);
      }

      return a.prioridade - b.prioridade;
    });
  }

  async createLinkCategory(category: any) {
    let link = "";
    let type = "linha";

    if (category) {
      if (!category.parent_id) {
        link = `/linhas/${category.slug}`;
        return link;
      }

      if (category.subcategorias) {
        type = "categoria";
      } else {
        type = "subcategoria";
      }

      if (type == "categoria") {
        let line: any = await this.loadProductLine(category.parent_id);
        if (category && line) {
          link = `/linhas/${line.slug}/${category.slug}`;
          return link;
        }
      }

      if (type == "subcategoria") {
        let subCategory: any = await this.loadProductLine(category.parent_id);
        let line: any = await this.loadProductLine(subCategory.parent_id);
        if (line && subCategory) {
          link = `/linhas/${line.slug}/${subCategory.slug}/${category.slug}`;
          return link;
        }
      }
    }
    return "/linhas";
  }

  async setLinkInCategory(category:any){
    category.link = await this.createLinkCategory(category);
    if(category.categorias){
      for(let i = 0; i < category.categorias.length; i++) {
        category.categorias[i] = await this.setLinkInCategory(category.categorias[i]);
      }
    }
    if(category.subcategorias){
      for(let i = 0; i < category.subcategorias.length; i++) {
        category.subcategorias[i] = await this.setLinkInCategory(category.subcategorias[i]);
      }
    }
    return category;
  }

  public async loadCategoriesWithLink() {
    for(let category of this.categories){
      await this.setLinkInCategory(category);
    }
    return this.categories;
   }

   async loadProductBySlug(slug: string){

    let productsAll = await this.loadProducts();
    let product: any;

    if(productsAll){
      product = productsAll.filter((res) => {
        let respostaSlug = res.slug || res.codPro;
        let sanitizedSlug = slug || '';

        respostaSlug = respostaSlug.replace(/®/g, '');
        sanitizedSlug = sanitizedSlug.replace(/®/g, '');

        return sanitizedSlug == respostaSlug || res.codPro == slug;
      });
    }

    if(!product.length){
      this.router.navigate(['/404']);
      console.log("Product undefined")
      return;
    }

    return product[0].nome ? product[0].nome : product[0].desPro;
   }

}
